import React from 'react';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { Typography } from '@mui/material';

const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip
        {...props} classes={{ popper: className }}
        title={
            <React.Fragment
            >
                <Typography color="inherit"
                    onClick={props.onClick}
                >
                    {props.title}</Typography>
                {props.title2 &&
                    <Typography color="inherit"
                        onClick={props.onClick}
                        sx={{
                            textAlign: 'center',
                            cursor: 'pointer'
                        }}>
                        {props.title2}
                    </Typography>}
            </React.Fragment>
        }
        sx={{
            ...props.sx,
            paddingTop: '15px',
            paddingBottom: '20px',
            cursor: 'pointer',
            zIndex: 1
        }}
        slotProps={props.slotProps || {
            popper: {
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            offset: [0, -25],
                        },
                    },
                ],
                sx: {
                    padding: 0,
                    zIndex: 0
                }
            },
        }}
    />
))(() => ({
    [`& .${tooltipClasses.tooltip}`]: {
        background: 'transparent',
        color: 'rgb(59, 126, 178)',
        boxShadow: '',
        fontSize: 15,
        margin: '0 !important',
    },
}));

export default LightTooltip